module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("My deepest thanks to those who taught me all about Youngstown: Chief James T. McBride, Sheriff Duke Wellington, and Bob O’Malley.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To the Doctors at the Cleveland Clinic: Michael Rocco, A. Marc Gillinov, and Robert Juhasz, who taught me how to get my wheels back on the track.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And always and forever to Holly Albin, who teaches me each day about love, friendship, loyalty, and courage.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0